import type { ReactNode } from "react";

/*
 * Messages. Errors have a red (danger) edge, success is sage, information is
 * neutral and warnings or pending states are gold. Terracotta stays the brand
 * colour, so an error never looks like a call to action. Backgrounds are
 * opaque so notices read the same inside a dark site preview.
 */
const tones = {
  error: "border-hazumu-danger/40 bg-hazumu-blush text-hazumu-ink",
  success: "border-hazumu-sage/40 bg-hazumu-sage-pale text-hazumu-sage-deep",
  info: "border-hazumu-border bg-hazumu-canvas text-hazumu-ink",
  warning: "border-hazumu-gold/60 bg-hazumu-gold-pale text-hazumu-ink",
} as const;

export const Notice = ({
  tone = "error",
  size = "md",
  className = "",
  children,
}: {
  tone?: keyof typeof tones;
  size?: "sm" | "md";
  className?: string;
  children: ReactNode;
}) => (
  <div
    role={tone === "error" ? "alert" : "status"}
    className={`rounded-xl border ${size === "sm" ? "px-3 py-2 text-xs leading-5" : "px-4 py-3 text-sm leading-6"} ${tones[tone]} ${className}`}
  >
    {children}
  </div>
);
